<template name="dateTimePicker">
  <div>
    <input
      type="text"
      :class="hasclass ? hasclass : 'time-input'"
      :placeholder="placeholder"
      @click="showPicker"
      :value="pickerValueStr"
      readonly>
    <input
      ref="picker"
      v-model="pickerValue"
      data-role="date-picker"
      class="input-hidden"
    >
  </div>
</template>

<script type="text/javascript">
import Moment from 'moment';
import Vue from 'vue';
import 'mint-ui/lib/style.css';
// import 'mint-ui/lib/datetime-picker/style.css';
import { DatetimePicker } from 'mint-ui';

import '../utils/mobiscroll';
import '../utils/mobiscroll.css';
import $ from 'jquery';

/**
 * Usage example:
 * bind placeholder to display placeholder for datetime picker
 * v-model with date str('' or 'YYYY-MM-DD HH:mm');
 * bind change event to handle selected date str
 * <dateTimePicker
 *  placeholder="Please select start date"
 *  v-model="startDate"
 *  @change="handleChange"
 *  ></dateTimePicker>
 */

export default {
  name: 'dateTimePicker',
  props: {
    placeholder: String,
    isStartDate: Boolean,
    isEndDate: Boolean,
    type: String,
    hasclass: String
  },
  model: {
    event: 'change',
  },
  data() {
    return {
      opt: {
        preset: '',
        maxDate:null,
        minDate:null,
        defaultValue:null,
        dateOrder: 'yymmdd',
        dateFormat: 'yy-mm-dd',
        stepMinute: 1,
        setText: '确认',
        cancelText: '取消',
        yearText: '年',
        monthText: '月',
        dayText: '日',
        hourText:'小时',
        minuteText:'分',
      }
    };
  },
  mounted() {
    this.initMobiscrollTime();
  },
  created() {
    const { isStartDate, isEndDate } = this.$props;
    // get current moment
    const currentMoment = Moment(new Date());
    // set minDate to first date of current year (date range picker)
    // or -100 years from now (single date picker)
    const minDate = (isStartDate || isEndDate)
      ? currentMoment.clone().dayOfYear(1).hours(0).minutes(0)
        .toDate()
      : currentMoment.clone().subtract(100, 'years').hours(0).minutes(0)
        .toDate();
    this.opt.minDate = minDate;

    // set maxDate to  1 (date range picker) or 100(single picker) years from now;
    const maxDate = currentMoment.clone().add((isStartDate || isEndDate) ? 1 : 100, 'years').toDate();
    this.opt.maxDate = maxDate;

    const pretype = this.type ? this.type : 'datetime';
    this.opt.preset = pretype;
  },
  computed: {
    pickerValue: {
      get() {
        const { isEndDate } = this.$props;
        const { value } = this.$attrs;
        let currentMoment = Moment(new Date());
        if (isEndDate) {
          currentMoment = currentMoment.hours(18).minutes(0);
        } else { // start date picker or single date picker
          currentMoment = currentMoment.hours(0).minutes(0);
        }
        return value ? Moment(value).toDate() : currentMoment.toDate();
      },
      set() {
      },
    },
    pickerValueStr() {
      return this.$attrs.value;
    },
  },
  methods: {
    showPicker(event) {
      $(this.$refs.picker).mobiscroll('setDate', this.pickerValue, true);
      $(this.$refs.picker).mobiscroll('show');
      event.currentTarget.blur();
    },
    formatDateToStr(date) {
      if (this.type == 'date') {
        return date.format('YYYY-MM-DD');
      } else {
        return date.format('YYYY-MM-DD HH:mm');
      } 
    },
    handleConfirm(dateObj) {
      const selectedMoment = Moment.utc(dateObj);
      const formatedDateStr = this.formatDateToStr(selectedMoment);
      this.$emit('change', formatedDateStr);
    },
    initMobiscrollTime(){
      let timerId;
      const self = this;
      $(this.$refs.picker).mobiscroll('destroy').mobiscroll(
        $.extend(this.opt, {
          theme: 'mobiscroll',
          mode: 'scroller',
          display: 'modal',
          lang: 'zh',
          animate: 'slidevertical',
          onSelect: (value) => {
            if (value) {
              this.handleConfirm(value);
            }
          },
          onBeforeShow: function (event, inst) {
            timerId = setInterval(function () {
              if (document.activeElement) {
                if (document.activeElement.getAttribute('data-role') == 'date-picker') {
                  document.activeElement.blur();
                }
              }
            }, 50);
          },
          onBeforeClose: function (event, inst) {
            clearInterval(timerId);
          },
        })
      );
    }
  },
};
</script>

<style lang="scss">
  .mint-datetime-action {
    font-weight: bold;
    color: #e42029;
  }
  .input-hidden{
    display: none;
  }
  .dw-persp{
    z-index: 10000;
  }
  .dw{
    z-index: 10001;
  }
</style>
<style lang="scss" scoped>
  .time-input {
    // width: 100% !important;
    text-align: right !important;
    margin-bottom: 0;
    background: url('../assets/images/arrow-copy.png') no-repeat right;
    background-size: 8px;
    padding-right: 20px !important;
    color: #4a4a4a;
    border: none !important;
    font-size: 13px;
    &::-webkit-input-placeholder {
      color: #929292;
    }
  }
  .no-style {
    background: none;
    padding-right: 0 !important;
    border: 1px solid #ccc;
    margin-bottom: 0;
    font-size: 14px;
    margin-left: 0;
    padding: 0 4px;
    width: 120px;
    color: #434343;
    vertical-align: top;
  }
  .no-style1 {
    background: none;
    padding-right: 0 !important;
    margin-bottom: 0;
    font-size: 14px;
    margin-left: 0;
    padding: 0 4px;
    width: 100%;
    line-height: 24px;
    color: #434343;
    vertical-align: top;
  }
</style>
